import {Permission, PermissionType} from '@hconnect/apiclient'
import {
  getPlantIdsPerCountryMap,
  type PlantIdsPerCountryMap,
  useUpmPlantsContext
} from '@hconnect/upm'

import {parseAndFilterPermissions} from '../helpers/parseAndFilterPermissions'

import {usePermissionsQuery} from './queries'

export const getPlantIdsForPermissions = (
  permissions: Permission[],
  plantIdsForCountryMap: PlantIdsPerCountryMap
) => {
  const plantIdsSet = new Set<string>()

  parseAndFilterPermissions(permissions).forEach(({parsedDataScope: {plantId, countryId}}) => {
    if (plantId) {
      plantIdsSet.add(plantId)
    } else if (countryId) {
      plantIdsForCountryMap[countryId]?.forEach((id) => plantIdsSet.add(id))
    }
  })

  return Array.from(plantIdsSet)
}

export const usePlantsByPermission = (permission: PermissionType) => {
  const {data: permissions = [], isLoading} = usePermissionsQuery()
  const filteredPermissions = permissions.filter((p) => p.permissionType === permission)

  const upmPlants = useUpmPlantsContext()
  const plantIdsForCountryMap = getPlantIdsPerCountryMap(upmPlants)

  const plantIds = getPlantIdsForPermissions(filteredPermissions, plantIdsForCountryMap)

  return {plantIds, isLoading}
}
